import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as R from 'ramda'

import FormHeader from 'components/FormHeader'
import FormFooter from 'components/FormFooter'
import LeftSide from './LeftSide'
import RightSide from './RightSide'
import Wizard from './wizardComment'

import Deleted from 'components/Deleted'
import PropertyStatusIcon from './StatusIcon'
import Divider from 'material-ui/Divider'

import { doc, dirtyRead, bufferById } from 'selectors/common'
import { propertiesLLEx } from 'selectors/properties'
import dataActions from 'actions/dataActions'
import { transactions, merchants, leases, projects, comments} from 'selectors/entities'
import { findInCollection } from 'utils/search'
import Geolocation from 'components/drivers/Geolocation'

let select = dirtyRead(
	(state, props) => {
		return ({
			property: doc(state, props.id || props.routeParams.id)
		  , isEditing: !!bufferById(state, props.id || props.routeParams.id)
		  , vendors: merchants(state)
		  , transactions: transactions(state)
		  , leases: leases(state)
		  , projects: projects(state)
		  , events: propertiesLLEx(state)[props.propertyID]
		  , comments: comments(state)
			, commentWizard: state.commentWizard
		})
	}
)

export class PropertyForm extends Component{
	render(){
		let { props } = this
		let propertyID = this.props.id || this.props.routeParams.id
		let colspan = this.props.colspan || 2
		let property = this.props.property || {}
		let widthColumns = (this.props.style && this.props.width && colspan)?(this.props.width.split('px')[0]/colspan)-18+"px":"50%"
		//console.log(this.props.events[props.id || props.routeParams.id]);
		//debugger
		return(
			<div
				style={{
					display: "inline-block"
				  , width: "100%"
				  , overflow: "hidden"
				}}
			>

				{this.props.property && (!this.props.property.cors || !Object.keys(this.props.property.cors).length) && this.props.property.address && <Geolocation
					address={this.props.property.address}
					onSuccess={(cors) => this.props.STAGE({_id: propertyID, cors: (JSON.parse(cors).results.length) ? JSON.parse(cors).results[0].geometry.location : {}})}
				/>}
				<FormHeader
					title={(this.props.property && this.props.property.alias)? this.props.property.alias : this.props.isEditing && "New property"}
					statusIcon={<PropertyStatusIcon id={propertyID} />}
					masterDetail={this.props.masterDetail || false}
					objectID= {propertyID}
					entity='property'
					deleteDisabled='Please contact mennager for deleting'
				/>
				{(!this.props.property)?
					<Deleted />
					:
					<div style={{position:"relative", height:"calc(100vh - 64px)", overflowX: "hidden"}}>
					<main style={{minHeight:"calc(100vh - 64px)", display:(colspan>1)?"flex":"block"}}>
		  				<LeftSide propertyID={propertyID} colspan={colspan}/>
						{colspan==1 && <Divider style={{marginTop: "0px"}}/>}
						<RightSide propertyID={propertyID} colspan={colspan} propertyAlias={(this.props.property.alias)?this.props.property.alias:"All properties"}/>
					</main>
					{propertyID &&
						<div
							style={{
								position:"fixed"
						      , zIndex:"9999"
							  , bottom:"3px"
							  , right:"17px"
							  , boxSizing: "borderBox"
							  , maringRight: "17px"
							}}
						>
							<FormFooter
								masterDetail={this.props.masterDetail || false}
								objectID={propertyID}
								cancel={true}
							/>
						</div>
					}
					</div>
				}

			</div>
		)
	}
}

export default connect(select, dataActions)(PropertyForm)



// WEBPACK FOOTER //
// ./src/routes/landlord/propertyForm/index.js